"use strict";

import Vue from 'vue';
import axios from "axios";

const apiOrigin = process.env.VUE_APP_API_ORIGIN || 'http://localhost:8000';

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
  baseURL: apiOrigin,
  timeout: 60 * 1000, // Timeout
  withCredentials: true, // Check cross-site Access-Control
  headers: {
    'Content-Type': 'application/json'
  }
};

const _axios = axios.create(config);

// 添加请求拦截器
_axios.interceptors.request.use(
  function(config) {
    // 在请求发送前处理请求配置
    return config;
  },
  function(error) {
    //处理请求错误处理请求错误
    return Promise.reject(error);
  }
);


//响应拦截器
_axios.interceptors.response.use(
  function(response) {
   // 处理响应数据
    return response;
  },
  function(error) {
    // 处理响应错误
    return Promise.reject(error);
  }
);

Plugin.install = function(Vue, options) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    },
  });
};

Vue.use(Plugin)

export default Plugin;
